import { z } from 'zod'
import { LoginManagerAccountType } from '@/enums/login-manager-account-type'
import { useStorage } from '~library/composables'
import { Identity, LocalStorage } from '~library/enums'

const rememberLoginInfoSchema = z.object({
  /** 身分別 */
  identity: z.nativeEnum(Identity),
  /** 經理人帳號類型 */
  managerAccountType: z.nativeEnum(LoginManagerAccountType),
  /** 帳號 */
  account: z.string()
})

export type RememberLoginInfo = z.infer<typeof rememberLoginInfoSchema>

export function useRememberLoginInfo() {
  const { getStorageData, setStorageData, removeStorageData } = useStorage()

  const saveIsRememberLoginInfo = (data: RememberLoginInfo | null) => {
    if (data) {
      setStorageData(LocalStorage.IS_REMEMBER_LOGIN_INFO, data)
    } else {
      removeStorageData(LocalStorage.IS_REMEMBER_LOGIN_INFO)
    }
  }

  const getIsRememberLoginInfo = (): RememberLoginInfo | null => {
    return (
      getStorageData({
        key: LocalStorage.IS_REMEMBER_LOGIN_INFO,
        zodSchema: rememberLoginInfoSchema
      }) ?? null
    )
  }

  return {
    saveIsRememberLoginInfo,
    getIsRememberLoginInfo
  }
}
